import { useState, useEffect } from 'react';
import { TransactionDetails } from '../../../../types/api.types';
import './InstallmentCards.scss';
import { InstallmentBreakdown } from '../InstallmentBreakdowns/InstallmentBreakdowns';
import { getInstallmentBanksAPI } from '../../../../services/installment.service';
import { Loader } from '../../../../pages/Loader/Loader';

export interface CardOptions {
  details: TransactionDetails;
  response: any;
  selectedBank: string;
  selectedPlan: string;
  providerKey: string;
  onBankSelect: (bankId: string) => void;
  onPlanSelect: (planId: string, provider: string, period?: number) => void;
  cardResponse: any;
}

interface Bank {
  bank_id: string;
  name: string;
  display_name: string;
  logo: string;
}

export const InstallmentCards = ({
  details,
  response,
  selectedBank,
  selectedPlan,
  providerKey,
  onBankSelect,
  onPlanSelect,
  cardResponse,
}: CardOptions) => {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBanks = async () => {
      setIsLoading(true);
      try {
        const banksResponse = await getInstallmentBanksAPI(
          details.data.onepay_transaction_id
        );
        if (banksResponse && banksResponse.status === 200) {
          setBanks(banksResponse.data);
        }
      } catch (error) {
        console.error('Error fetching banks:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanks();
  }, [details.data.onepay_transaction_id]);

  return (
    <div>
      {!selectedBank && (
        <div className="installment-option mb-4">
          Installment plans <span>Credit Card Only</span>
        </div>
      )}

      {isLoading && <Loader />}

      {!selectedBank && !isLoading && (
        <>
          {banks.map((bank) => (
            <div
              key={bank.bank_id}
              onClick={() => onBankSelect(bank.bank_id)}
              className="installment-cards d-flex justify-content-between"
            >
              <div>
                <img height={30} src={bank.logo} alt={bank.display_name} />
              </div>
              <div className="cc-btn">Credit Card</div>
            </div>
          ))}
        </>
      )}

      {selectedBank && (
        <InstallmentBreakdown
          details={details}
          response={response}
          bankId={selectedBank}
          selectedBank={banks.find((bank) => bank.bank_id === selectedBank)}
          selectedPlan={selectedPlan}
          providerKey={providerKey}
          onPlanSelect={onPlanSelect}
          onBankSelect={onBankSelect}
          cardResponse={cardResponse}
        />
      )}
    </div>
  );
};
